import {Injectable, inject} from "@angular/core";
import {Observable, of, take} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {environment} from "@env/environment";

export enum UserProfile {
    ADMIN = 'ADMIN',
    PROFESSIONAL = 'PROFESSIONAL'
}

export enum UserStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}

export interface User {
    id?: number;
    firstName: string;
    lastName: string;
    email: string;
    password?: string;
    profile: UserProfile;
    status: UserStatus;
}

@Injectable({
    providedIn: 'root'
})
export class UsersApiService {
    private http = inject(HttpClient);
    private readonly apiServiceUrl = environment.serviceApi;

    findAll(params: any): Observable<any> {
        return this.http.get(`${this.apiServiceUrl}/v1/users`, {params})
            .pipe(take(1));
    }

    findById(id: number): Observable<any> {
        return this.http.get(`${this.apiServiceUrl}/v1/users/${id}`)
            .pipe(take(1));
    }

    create(user: User): Observable<any> {
        return this.http.post(`${this.apiServiceUrl}/v1/users`, user)
            .pipe(take(1));
    }

    update(id: number, user: User): Observable<any> {
        return this.http.put(`${this.apiServiceUrl}/v1/users/${id}`, user)
            .pipe(take(1));
    }

    delete(id: number): Observable<any> {
        return this.http.delete(`${this.apiServiceUrl}/v1/users/${id}`)
            .pipe(take(1));
    }

    updateStatus(id: number, status: UserStatus): Observable<any> {
        return this.http.patch(`${this.apiServiceUrl}/v1/users/${id}/status`, {status})
            .pipe(take(1));
    }
}
